import { useCan, useRealTimeTypedQuery, useSelectedLocation } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { useParkingGateCodesListeners } from "modules/ParkingGateCodesDashboard/listeners";
import { ParkingGateCodesDashboardQueryKeys } from "modules/ParkingGateCodesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { ParkingGateCode } from "models";

const sortParkingGateCodes = (parkingGateCodes: ParkingGateCode[]) =>
  parkingGateCodes.sort(
    (a, b) => new Date(a.start_at).getTime() - new Date(b.start_at).getTime() || new Date(a.end_at).getTime() - new Date(b.end_at).getTime() || a.id - b.id
  );

export const useParkingGateCodesQuery = () => {
  const listeners = useParkingGateCodesListeners();
  const { selectedLocation } = useSelectedLocation();
  const canListParkingGateCodes = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.ParkingGateCode);

  return useRealTimeTypedQuery({
    queryKey: ParkingGateCodesDashboardQueryKeys.parkingGateCodes,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id }, baseUrl)).data.parking_gate_code,
    select: sortParkingGateCodes,
    enabled: canListParkingGateCodes && Boolean(selectedLocation?.id),
    refetchOnDependencies: [selectedLocation?.id, canListParkingGateCodes],
    listeners
  });
};
